var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "    <div>\r\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isAccessAllowed : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper;

  return "        <div class=\"alert alert-success\">\r\n            Velkommen <strong>"
    + container.escapeExpression(((helper = (helper = helpers.userName || (depth0 != null ? depth0.userName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"userName","hash":{},"data":data}) : helper)))
    + "</strong>.<br />\r\n            I Internt Tidende kan du godkende eller afvise ventende publiceringer.\r\n        </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var helper;

  return "        <div class=\"alert alert-danger\">\r\n            <strong>"
    + container.escapeExpression(((helper = (helper = helpers.userName || (depth0 != null ? depth0.userName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"userName","hash":{},"data":data}) : helper)))
    + "</strong>.<br />\r\n            Du har ikke rettigheder til at se og godkende ventende publiceringer!\r\n        </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "<div class=\"alert alert-warning\">   \r\n    <p>Henter bruger... <i class=\"static-busy-indicator fa fa-spinner fa-spin fa-fw\"></i></p>\r\n</div>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.userName : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/Tidings/user.hbs
// module id = 59
// module chunks = 0